import React, { useState, FC } from 'react';

import { MarketoFormInterface } from '@lucid/utils';
import { ABTest, ABTestBranch, MarketoForm, ABTestVariation } from '@lucid/components-react';
import { graphql, useStaticQuery } from 'gatsby';

import FormComplete from './form-complete';

interface ZoomInfoRestrictDomainsProps {
  langPrefix: string;
  location: {
    pathname?: string;
    origin?: string;
    search?: string;
  };
  marketoForm: MarketoFormInterface;
  submitText: string;
  marketoTitle: string | undefined;
  marketoOnSuccess: () => JSX.Element;
  fieldZoominfoFormcompleteForm?: string;
}

const signUpUrl = 'https://lucid.app/pricing/lucidchart#/pricing';
const updatedTopText =
  `We'll be in touch soon to answer your Enterprise Questions.
    Need a personal or team plan? Sign up
    <a href="${signUpUrl}" rel="noreferrer"> here</a>.`;

const ABTestZoominfoRestrictDomains: FC<ZoomInfoRestrictDomainsProps> = ({
  langPrefix,
  location,
  marketoForm,
  submitText,
  marketoTitle,
  marketoOnSuccess,
  fieldZoominfoFormcompleteForm
}) => {
  const { allFreeDomainsJson: { edges } } = useStaticQuery(
    graphql`
      {
        allFreeDomainsJson {
          edges {
            node {
              domain
            }
          }
        }
      }
    `
  );
  const freeDomains = edges.map((edge: any) => edge.node.domain);

  const [willAllowZoominfo, setAllowZoominfo]  = useState(false);

  return (
    <ABTest
      isAboveTheFold
      hasConditionalTrigger={langPrefix === 'en'}
      test="Y21Q3_ZoomInfoRestrictFreeDomains"
      trigger="load"
    >
      <ABTestBranch branch={ABTestVariation.A}>
        <MarketoForm
          fullWidth
          fullWidthSubmit
          showTerms
          useReferrer
          willRestrictFreeDomains
          form={marketoForm}
          freeDomains={freeDomains}
          location={location}
          showLabels={false}
          submitText={submitText}
          topText={{
            body: `<h1 style="margin-top:0; font-size: 1.5rem">${marketoTitle}</h1>
            <p>${updatedTopText}</p>`
          }}
        >
          {marketoOnSuccess()}
        </MarketoForm>
      </ABTestBranch>
      <ABTestBranch branch={ABTestVariation.B}>
        <MarketoForm
          fullWidth
          fullWidthSubmit
          showTerms
          useReferrer
          willRestrictFreeDomains
          form={marketoForm}
          freeDomains={freeDomains}
          location={location}
          setAllowZoominfo={setAllowZoominfo}
          showLabels={false}
          submitText={submitText}
          topText={{
            body: `<h1 style="margin-top:0; font-size: 1.5rem">${marketoTitle}</h1>
            <p>${updatedTopText}</p>`
          }}
        >
          {marketoOnSuccess()}
        </MarketoForm>
        <FormComplete
          fieldZoominfoFormcompleteForm={fieldZoominfoFormcompleteForm}
          willAllowZoominfo={willAllowZoominfo}
        />
      </ABTestBranch>
    </ABTest>
  );
};

export default ABTestZoominfoRestrictDomains;
